export default "::ng-deep .control-pop-up .dx-popup-content{padding:0}";